import React from "react";

const PrizeDistributionRulesList = React.lazy(() => import('src/pages/prize_distribution_rules/PrizeDistributionRulesList'));
const AddPrizeDistributionRules = React.lazy(() => import('src/pages/prize_distribution_rules/AddPrizeDistributionRules'));
const EditPrizeDistributionRules = React.lazy(() => import('src/pages/prize_distribution_rules/EditPrizeDistributionRules'));

const routes = [
    { path: '/dashboard/prize-distribution-rules-list/add', name: 'Add Prize Distribution Rule', element: AddPrizeDistributionRules },
    { path: '/dashboard/prize-distribution-rules-list/edit', name: 'Edit Prize Distribution Rule', element: EditPrizeDistributionRules },
    { path: '/dashboard/prize-distribution-rules-list', name: 'Prize Distribution Rules', element: PrizeDistributionRulesList },
];

export default routes;
